/** 素材库弹窗：内嵌官网页面；若站点禁止 iframe 则区域可能空白，请用「新窗口打开」 */
import { BaseWebUrl } from '@/utils/request/baseWebUrl'

export interface MaterialEmbedPage {
  label: string
  url: string
}

const webUrl = new BaseWebUrl()
const website = webUrl.baseWebsite.replace(/\/+$/g, '')

export const MATERIAL_EMBED_PAGES: MaterialEmbedPage[] = [
  { label: '橙娘素材铺', url: `${website}/Drawtrade/goods/goodslist` },
  { label: '官方精选专题', url: `${website}/monthly/t_21/3478.shtml` },
]

export const MATERIAL_MALL_RULE_URL = `${website}/redirect/mall_rule`
